import { dispatch } from 'store';
import { openSnackbar } from 'store/reducers/snackbar';

export const showErrorToast = (Message: string) => {
  dispatch(
    openSnackbar({
      open: true,
      message: Message,
      variant: 'alert',
      alert: {
        color: 'error'
      },
      close: true,
      autoHideDuration: 5000
    })
  );
};
